import { combineReducers } from 'redux';

import profileDataReducer from './profileDataReducer';
import profileUiReducer from './profileUiReducer';

export default combineReducers({
  data: profileDataReducer,
  ui: profileUiReducer,
});
